import React, { useState, useRef } from 'react';
import YouTube from 'react-youtube';

import useAuth from '~/hooks/useAuth';

import dabangBridge from '~/utils/bridge';
import apiCall, { LIVE_URL } from '~/utils/apiCall';

import BG from '~/components/background';

import top from './images/top.png';
import bottom from './images/bottom.png';

import q1 from './images/01.png';
import q2 from './images/02.png';
import q3 from './images/03.png';
import q4 from './images/04.png';
import q5 from './images/05.png';

import q1C from './images/01-checked.png';
import q2C from './images/02-checked.png';
import q3C from './images/03-checked.png';
import q4C from './images/04-checked.png';
import q5C from './images/05-checked.png';

import youtubeImg from './images/go-youtube.png';
import answerImg from './images/go-answer.png';

import { Wrap, TopWrap, BottomWrap, AgreeWrap, LabelWrap, Label, Checkbox, Ul } from './styled'; 

function Arrow() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path fill="#fafdff" d="M0 0H40V40H0z" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000)"/>
              <path stroke="#9FABC4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M27 9L27 23 13 23" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000) translate(20.000000, 16.000000) rotate(-315.000000) translate(-20.000000, -16.000000)"/>
          </g>
          </g>
        </g>
      </g>
  </svg>
  );
}

function MainComponent() {
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [answer, setQuestion] = useState(null);

  const { authKey } = useAuth();

  const agreeText1 = [
    '1. 개인정보 수집 및 이용 목적 : 당첨자 선정',
    '2. 수집하려는 개인정보의 항목 : 이름, 휴대폰 번호',
    '3. 개인정보의 보유 및 이용 기간 : 당첨자 선정 후 3개월간 보관 후 파기됩니다.',
    '4. 본 개인정보 제공에 동의를 거부할 권리가 있으며 동의 거부 시 이벤트 참여가 제한됩니다.',
    '5. 제공하신 개인정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
  ];

  const agreeText2 = [
    '1. 개인정보를 제공 받는 자 : 티아이커머스',
    '2. 개인정보를 제공받는자의 개인정보 이용목적 : 경품발송',
    '3. 제공하는 개인정보의 항목 : 휴대폰 번호',
    '4. 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간 : 경품발송 후 3개월간 보관 후 파기',
    '5. 본 개인정보 제공에 동의를 거부할 권리가 있으며 동의 거부 시 이벤트 참여가 제한됩니다.',
    '6. 제공하신 개인정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
  ];

  const clickQustion = idx => {
    if (answer === idx) return;
    setQuestion(idx);
  }

  const submit = async () => {
    if (!agree1) return alert('개인정보 수집/이용 에 대한 동의를 체크 해주세요.');
    if (!agree2) return alert('개인정보 제공(위탁)에 대한 동의를 체크 해주세요.');
    if (!answer) return alert('보기를 선택 후 참여해주세요.');

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/20210716-second`, { authKey, answer });
      const errorCode = [502, 503, 504, 505];

      if (res?.code === 501) {
        alert(res?.msg);

        dabangBridge.ios(call => {
          call.callHandler('ObjC Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        dabangBridge.android(call => {
          call.showLoginAndReload();
        });

        return;
      }

      if (errorCode.includes(res?.code)) return alert(res?.msg);

      alert('이벤트 참여 완료');

      dabangBridge.ios(call => {
        call.callHandler('ObjC Echo', {
          cmd: 'finishActivity',
        });
      });
  
      dabangBridge.android(call => {
        call.finishActivity();
      });

    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return (
    <Wrap>
      <TopWrap>
        <div className="youtube-wrap">
          <YouTube videoId="VAJBY2UoD18" />
        </div>
        <BG width={710} height={2090} imgUrl={top} />
      </TopWrap>

      <AgreeWrap>
        <LabelWrap>
          <Label isCheck={agree1}>
            <Checkbox type="checkbox" checked={agree1} onChange={() => setAgree1(prev => !prev)} />
            <p>개인정보 수집/이용 에 대한 동의</p>
            <Arrow />
          </Label>
  
          {agree1 && (
            <Ul>
              {agreeText1.map((text, key) => (
                <li key={key}>{text}</li>
              ))}
            </Ul>
          )}
        </LabelWrap>
  
        <LabelWrap>
          <Label isCheck={agree2}>
            <Checkbox type="checkbox" checked={agree2} onChange={() => setAgree2(prev => !prev)} />
            <p>개인정보 제공(위탁)에 대한 동의</p>
            <Arrow />
          </Label>
  
          {agree2 && (
            <Ul>
              {agreeText2.map((text, key) => (
                <li key={key}>{text}</li>
              ))}
            </Ul>
          )}
        </LabelWrap>
      </AgreeWrap>
  
      <BottomWrap>
        <div className="answer">
          <img className="q1" src={answer && answer === '여행' ? q1C : q1} alt="" onClick={() => clickQustion('여행')} />
          <img className="q2" src={answer && answer === '자취' ? q2C : q2} alt="" onClick={() => clickQustion('자취')} />
          <img className="q3" src={answer && answer === '독립' ? q3C : q3} alt="" onClick={() => clickQustion('독립')} />
          <img className="q4" src={answer && answer === '휴가' ? q4C : q4} alt="" onClick={() => clickQustion('휴가')} />
          <img className="q5" src={answer && answer === '사랑' ? q5C : q5} alt="" onClick={() => clickQustion('사랑')} />
        </div>
        <img className="answerImg" src={answerImg} onClick={submit} />
        <img className="youtubeImg" src={youtubeImg} onClick={() => window.location.href = 'https://www.youtube.com/c/1sangdabangsa'} />
        <BG width={710} height={1594} imgUrl={bottom} />
      </BottomWrap>
    </Wrap>
  );
}

export default MainComponent;
